const escapeHtml = (s) => String(s || '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

export async function downloadInvoiceFile(api, itemId, filename, base = '/cost-inbox') {
  const r = await api.get(`${base}/${itemId}/file`, { responseType: 'blob' });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement('a');
  a.href = url; a.download = filename || 'invoice';
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}

/** Print every page as a full-width image from a hidden iframe (works for PDFs and photos alike). */
export async function printInvoicePages(api, itemId, pageCount, title, base = '/cost-inbox') {
  const blobs = await Promise.all(Array.from({ length: Math.max(1, pageCount) }, (_, i) =>
    api.get(`${base}/${itemId}/pages/${i}?width=1600`, { responseType: 'blob' }).then(r => r.data)));
  const urls = blobs.map(b => URL.createObjectURL(b));
  const iframe = document.createElement('iframe');
  iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden;';
  document.body.appendChild(iframe);
  const doc = iframe.contentDocument;
  doc.open();
  doc.write(`<!doctype html><html><head><title>${escapeHtml(title)}</title>
<style>@page{margin:8mm}body{margin:0}img{display:block;width:100%;page-break-after:always;break-after:page}img:last-child{page-break-after:auto;break-after:auto}</style>
</head><body>${urls.map(u => `<img src="${u}" alt="">`).join('')}</body></html>`);
  doc.close();
  await Promise.all(Array.from(doc.images).map(img => (img.complete ? null : new Promise(res => { img.onload = res; img.onerror = res; }))));
  const cleanup = () => { urls.forEach(u => URL.revokeObjectURL(u)); iframe.remove(); };
  iframe.contentWindow.addEventListener('afterprint', cleanup, { once: true });
  setTimeout(cleanup, 120000);
  iframe.contentWindow.focus();
  iframe.contentWindow.print();
}
